import React from 'react'
import styles from "./FranchisePartner.module.css"
import IndiaMap from '../IndiaMap'
export default function FranchisePartnerMap() {
  return (
    <div style={{width:"100%",display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
        <h3>Our Franchise</h3>
        <div style={{width:"100%",height:"100%"}}>
        <IndiaMap/>
        </div>
    </div>
  )
}
